var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "render-post",
      staticClass: "container-render-post",
      style: { fontSize: _vm.fontSize + "px" },
    },
    [
      _c("div", { staticClass: "render-reel-facebook" }, [
        _c("div", { staticClass: "header-app" }, [
          _vm._v("\n            Reels\n        "),
        ]),
        _c(
          "div",
          { staticClass: "reel-content", on: { click: _vm.clickOnPost } },
          [
            _vm._l(
              _vm.medias
                .filter((m) => m.info.type.startsWith("video/"))
                .slice(0, 1),
              function (media, index) {
                return _vm.medias.length
                  ? _c("video", {
                      key: index,
                      class: { cover: media.info.aspectRatio <= 0.5625 },
                      attrs: {
                        autoplay: true,
                        loop: "",
                        playsinline: "",
                        preload: "metadata",
                        src: media.url,
                        type: media.info.type,
                      },
                      domProps: { muted: _vm.videoMuted },
                    })
                  : _vm._e()
              }
            ),
            _vm._m(0),
            _c("div", { staticClass: "info-reel" }, [
              _c("div", { staticClass: "page" }, [
                _c(
                  "div",
                  {
                    staticClass: "images",
                    class: { multiple: _vm.pages.length > 1 },
                  },
                  [
                    _vm._l(_vm.pages.slice(0, 3), function (page, index) {
                      return _c("img", {
                        key: index,
                        attrs: { src: page.avatar },
                        on: {
                          click: () => {
                            page.iconEdited
                              ? _vm.$emit("clickPage", page.id)
                              : _vm.openFacebookPage(page)
                          },
                        },
                      })
                    }),
                    _vm.pages.length > 3
                      ? _c("div", { staticClass: "count" }, [
                          _vm._v(
                            "\n                            +" +
                              _vm._s(_vm.pages.length - 3) +
                              "\n                        "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _c("div", { staticClass: "names" }, [
                  _vm.pages.length <= 1
                    ? _c(
                        "p",
                        {
                          staticClass: "page-name",
                          on: {
                            click: function ($event) {
                              return _vm.openFacebookPage(_vm.pages[0])
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.pages[0].name))]
                      )
                    : _vm._e(),
                  _vm.musicName && _vm.pages.length <= 1
                    ? _c("p", { staticClass: "music-name" }, [
                        _c("i", { staticClass: "fa-solid fa-music" }),
                        _vm._v(_vm._s(_vm.musicName)),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm.musicName && _vm.pages.length > 1
                ? _c("p", { staticClass: "music-name" }, [
                    _c("i", { staticClass: "fa-solid fa-music" }),
                    _vm._v(_vm._s(_vm.musicName)),
                  ])
                : _vm._e(),
              _vm.description
                ? _c("div", {
                    staticClass: "description-reel",
                    class: { "cut-content": !_vm.fullContent },
                    domProps: {
                      innerHTML: _vm._s(_vm.textTranslateMentionAndHastag),
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleFullContent.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _c("div", {
              key: _vm.videoMuted ? "no-sound" : "sound",
              class: _vm.videoMuted ? "no-sound" : "sound",
            }),
          ],
          2
        ),
      ]),
      _vm.modes.includes("addIdentifierMode")
        ? _c("SelectPerson", {
            attrs: {
              personsSelect: _vm.personsIdentified,
              positionClick: _vm.paramsContentOverflow.identify.positionClick,
              position: _vm.positionFormOverlay,
            },
            on: {
              close: _vm.closeContentOverflow,
              resetPositionClick: _vm.resetClick,
            },
          })
        : _vm._e(),
      _vm.modes.includes("addCollaboratorMode")
        ? _c("SelectPerson", {
            attrs: {
              personsSelect: _vm.collaborators,
              positionClick: _vm.paramsContentOverflow.identify.positionClick,
              position: _vm.positionFormOverlay,
            },
            on: {
              close: _vm.closeContentOverflow,
              resetPositionClick: _vm.resetClick,
            },
          })
        : _vm._e(),
      _vm.modes.includes("addPlaceMode")
        ? _c("SelectPlace", {
            attrs: {
              placeSelected: _vm.place,
              position: _vm.positionFormOverlay,
              network: "facebook",
            },
            on: { close: _vm.closeContentOverflow },
          })
        : _vm._e(),
      _vm.modes.includes("addMusicMode")
        ? _c("SelectMusic", {
            attrs: {
              musicSelected: _vm.music,
              position: _vm.positionFormOverlay,
            },
            on: { close: _vm.closeContentOverflow },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nav-lateral" }, [
      _c("div", { staticClass: "like" }),
      _c("div", { staticClass: "comment" }),
      _c("div", { staticClass: "send" }),
      _c("div", { staticClass: "more" }, [
        _c("i", { staticClass: "fa-solid fa-ellipsis" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }